import { PharmacyCard, PharmacyCardProps } from './pharmacy-card';
import { Divider } from '@heroui/react';

export type PharmacyCardsListProps = {
  items?: (PharmacyCardProps | undefined)[];
  isDivided?: boolean;
};

export const PharmacyCardsList = ({
  items = [],
  isDivided = true,
}: PharmacyCardsListProps) => {
  return (
    <div className="flex flex-col pt-4 gap-y-4">
      {items?.map((item, index) => {
        return (
          <div key={index}>
            <PharmacyCard {...item} />

            {isDivided && index + 1 !== items?.length && (
              <Divider className="mt-4 lg:mt-6" />
            )}
          </div>
        );
      })}
    </div>
  );
};
